import  { 	CARGAR_NOTACREDITO, INICIALIZAR_NOTACREDITO } from './actionTypes';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';
import global_axios from '../../funciones_globales/interaccionapi';

export const cargar_NotaCreditoPorCodigo = (idNotaCredito) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/notascredito/' + idNotaCredito
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let notaCredito = response.data;
			dispatch({
				type: CARGAR_NOTACREDITO,
				data: notaCredito
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar nota de crédito', mensaje: msgError}
			});
		});
	}
}

export const cargar_NotaCreditoPorNumero = (establec, ptoEmision, numero) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: `/notascredito/${establec}/${ptoEmision}/${numero}`
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let notaCredito = response.data;
			dispatch({
				type: CARGAR_NOTACREDITO,
				data: notaCredito
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar nota de crédito', mensaje: msgError}
			});
		});
	}
}

export const inicializarNotaCredito = () => {	
	return {
		type: INICIALIZAR_NOTACREDITO,
		data: {}
	};
}